var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "christmas" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("router-link", { attrs: { to: "/index" } }, [
              _c("i", { staticClass: "logo" })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _vm.mode == 0
              ? _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.switchMode()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("index_txtSwitchToPython")))]
                )
              : _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.switchMode()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("index_txtSwitchToBlocky")))]
                ),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/index" } }, [
              _vm._v(_vm._s(_vm.$t("sucPass_button")))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _vm.isVip == 1
          ? _c(
              "div",
              {
                staticClass: "announcement",
                class: { announcement__EN: _vm.lang === "en" }
              },
              [
                _c("div", { staticClass: "msgBox" }, [
                  _vm.$i18n.locale == "zh"
                    ? _c("b", { domProps: { innerHTML: _vm._s(_vm.announce) } })
                    : _c("b", {
                        domProps: { innerHTML: _vm._s(_vm.announce_en) }
                      })
                ]),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/event/Christmas2020/santa.png"),
                    width: "140px",
                    height: "140px"
                  }
                })
              ]
            )
          : _c(
              "div",
              {
                staticClass: "announcement",
                class: { announcement__EN: _vm.lang === "zh" }
              },
              [
                _c("div", { staticClass: "msgBox" }, [
                  _c("div", [
                    _vm.lang == "zh"
                      ? _c("b", {
                          domProps: { innerHTML: _vm._s(_vm.announce2) }
                        })
                      : _c("b", {
                          domProps: { innerHTML: _vm._s(_vm.announce2_en) }
                        }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            _vm.toVipPage()
                          }
                        }
                      },
                      [
                        _vm.lang == "zh"
                          ? _c("b", [_vm._v("升级为正式宇航员")])
                          : _c("b", [_vm._v("Upgrade to VIP")])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/event/Christmas2020/santa2.png"),
                    width: "140px",
                    height: "140px"
                  }
                })
              ]
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "myScore", class: { myScore__EN: _vm.lang === "en" } },
          [
            _c("div", { staticClass: "msgBox" }, [
              _c("section", [
                _vm.lang == "zh"
                  ? _c("div", { staticClass: "msgBox-left" }, [
                      _vm._v("通关关卡")
                    ])
                  : _c("div", { staticClass: "msgBox-left" }, [
                      _vm._v("Levels")
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "msgBox-right" }, [
                  _vm._v(_vm._s(_vm.rankPoints))
                ])
              ]),
              _vm._v(" "),
              _c("section", [
                _vm.lang == "zh"
                  ? _c("div", { staticClass: "msgBox-left" }, [
                      _vm._v("收集礼物")
                    ])
                  : _c("div", { staticClass: "msgBox-left" }, [
                      _vm._v("Score")
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "msgBox-right" }, [
                  _c("i", { staticClass: "gift-icon" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(" x " + _vm._s(_vm.giftNumber))])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "enterBtn" }, [
          _c("section"),
          _vm._v(" "),
          _vm.mode == 1
            ? _c(
                "section",
                [
                  _vm.isVip == 1
                    ? _c("a", {
                        staticClass: "enterBtn-py",
                        class: { "enterBtn-py__EN": _vm.lang === "en" },
                        on: {
                          click: function($event) {
                            _vm.enterEventGame()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("index_txt49_noOpen"),
                        placement: "top"
                      }
                    },
                    [
                      _vm.isVip == 0
                        ? _c("a", {
                            staticClass: "enterBtn-py-non",
                            class: { "enterBtn-py-non__EN": _vm.lang === "en" }
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _c(
                "section",
                [
                  _vm.isVip == 1
                    ? _c("a", {
                        staticClass: "enterBtn-blocky",
                        class: { "enterBtn-blocky__EN": _vm.lang === "en" },
                        on: {
                          click: function($event) {
                            _vm.enterEventGame()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("index_txt49_noOpen"),
                        placement: "top"
                      }
                    },
                    [
                      _vm.isVip == 0
                        ? _c("a", {
                            staticClass: "enterBtn-blocky-non",
                            class: {
                              "enterBtn-blocky-non__EN": _vm.lang === "en"
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
          _vm._v(" "),
          _c("section", [
            _vm.mode == 0
              ? _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.switchMode()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("index_txtSwitchToPython")))]
                )
              : _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.switchMode()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("index_txtSwitchToBlocky")))]
                )
          ])
        ]),
        _vm._v(" "),
        _c("a", {
          staticClass: "rankSearch",
          class: { rankSearch__EN: _vm.lang === "en" },
          on: {
            click: function($event) {
              ;(_vm.rankBoard = true),
                _vm.rankListSearch(_vm.pageSize, _vm.pageStart)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "christmas-rankBoard",
          attrs: {
            visible: _vm.rankBoard,
            "show-close": false,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.rankBoard = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "christmas-rankBoard__container",
              class: { "christmas-rankBoard__container__EN": _vm.lang === "en" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.rankBoardLoading,
                      expression: "rankBoardLoading"
                    }
                  ],
                  staticClass: "rankBoard",
                  attrs: {
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-text":
                      _vm.lang == "zh"
                        ? "排行榜数据读取中，请稍候..."
                        : _vm.lang == "en"
                        ? "Loading..."
                        : "",
                    "element-loading-background": "rgba(255, 255, 255, 0.95)"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "rankBoard-content" },
                    [
                      _c(
                        "el-table",
                        { attrs: { data: _vm.listQuery } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "rank",
                              label:
                                _vm.lang == "zh"
                                  ? "排名"
                                  : _vm.lang == "en"
                                  ? "Rank"
                                  : "",
                              width: "80",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label:
                                _vm.lang == "zh"
                                  ? "姓名"
                                  : _vm.lang == "en"
                                  ? "Name"
                                  : "",
                              width: "120",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.isVip == 1
                                      ? _c("span", { staticClass: "vipName" }, [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                // 如果长度大于6，省略后面的字符并句尾加上“...”
                                                scope.row.firstName.length > 6
                                                  ? scope.row.firstName.substring(
                                                      0,
                                                      6
                                                    ) + "..."
                                                  : scope.row.firstName
                                              )
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              // 如果长度大于6，省略后面的字符并句尾加上“...”
                                              scope.row.firstName.length > 6
                                                ? scope.row.firstName.substring(
                                                    0,
                                                    6
                                                  ) + "..."
                                                : scope.row.firstName
                                            )
                                          )
                                        ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label:
                                _vm.lang == "zh"
                                  ? "学校"
                                  : _vm.lang == "en"
                                  ? "School"
                                  : "",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            scope.row.schoolCnName.length > 20
                                              ? scope.row.schoolCnName.substring(
                                                  0,
                                                  20
                                                ) + "..."
                                              : scope.row.schoolCnName
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label:
                                _vm.lang == "zh"
                                  ? "收集礼物"
                                  : _vm.lang == "en"
                                  ? "Score"
                                  : "",
                              width: "120",
                              align: "center"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("div", { staticClass: "giftGetting" }, [
                                      _c("i", { staticClass: "gift-icon" }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.totalScore))
                                      ])
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rankBoard-pagination" },
                    [
                      _c("el-pagination", {
                        staticClass: "rankBoard-pagination__container",
                        attrs: {
                          layout: "prev, pager, next",
                          "current-page": _vm.pageStart,
                          "page-size": _vm.pageSize,
                          total: _vm.totalNum
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange,
                          "update:currentPage": function($event) {
                            _vm.pageStart = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.rankBoardLoading,
                      expression: "rankBoardLoading"
                    }
                  ],
                  staticClass: "progressBar",
                  attrs: {
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255, 255, 255, 0.95)"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "bar" },
                    [
                      _c("div", { staticClass: "bar-count" }, [
                        _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.currentProgressNum) +
                              " / " +
                              _vm._s(_vm.currentProgressTotalNum) +
                              "\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-progress", {
                        staticClass: "bar-top",
                        attrs: { percentage: _vm.percentage }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "bar-bg" })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm.lang === "zh"
                      ? _c("span", [_vm._v(_vm._s(_vm.currentProgressAward))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.lang === "en"
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.currentProgressAward_EN))
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "closeBtn",
                on: {
                  click: function($event) {
                    _vm.rankBoard = false
                  }
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("YUKI")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0b647d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0b647d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventChristmas.vue
// module id = null
// module chunks = 